import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';



import AuthenticationService from '@lib/auth/AuthenticationService';
import getAdvisorNotes from '@actions/advisor/getAdvisorNotes';
import saveAdvisorNotes from '@actions/advisor/saveAdvisorNotes';
import { useI18n } from '@lib/i18n';
import SmallToast from '@components/AdvsiorForm/dashboard/components/SmallToast/smallToast';
import NotesModal from '@components/AdvsiorForm/dashboard/components/Modal/notesModal';

export default function AdvisorNotesModalController({ children }) {
	const { t } = useI18n();
	const dispatch = useDispatch();

	const dialogRef = useRef(null);

	const [prospectusID, setProspectusID] = useState(false);
	const [notes, setNotes] = useState('');
	const [showToast, setShowToast] = useState(false);
	const [alertText, setToastText] = useState(false);
	const [isModalOpen, setIsModalOpen] = useState(false);

	useEffect(() => {
		const dialog = dialogRef.current;

		if (!dialog) {
			return;
		}

		if (isModalOpen && !dialog.open) {
			dialog.showModal();
		}

		if (!isModalOpen && dialog.open) {
			dialog.close();
		}
	}, [isModalOpen]);

	const getAuthToken = async () => {
		const auth = new AuthenticationService();

		let token = auth.getJwtTokenFromStorage();

		if (!token) {
			await auth.refreshToken()(dispatch);
			token = auth.getJwtTokenFromStorage();
		}

		return token || '';
	};

	const showAdvisorNotesToaster = (toastText = '') => {
		setToastText(toastText);
		setShowToast(true);

		const timer = setTimeout(() => {
			setShowToast(false);
		}, 3200);

		return () => clearTimeout(timer);
	};

	const openAdvisorNotes = async (prospectus_id) => {
		setProspectusID(prospectus_id);
		setNotes('');

		const token = await getAuthToken();

		if (!token) {
			showAdvisorNotesToaster(
				t('printer.error', 'We encountered an unexpected issue. Please log in again.')
			);
			return;
		}

		const result = await getAdvisorNotes(token, prospectus_id);

		if (typeof result === 'string') {
			setNotes(result);
		}

		setIsModalOpen(true);
	};

	const modalCloseHandler = () => {
		setNotes('');
		setIsModalOpen(false);
	};

	const modalSaveHandler = async (notes) => {
		const token = await getAuthToken();

		if (!token) {
			showAdvisorNotesToaster(
				t('printer.error', 'We encountered an unexpected issue. Please log in again.')
			);
			return;
		}

		const result = await saveAdvisorNotes(token, notes, prospectusID);

		if (result) {
			showAdvisorNotesToaster(
				t('printer.success', 'Success! Your profile notes have been saved.')
			);
			setIsModalOpen(false);
		} else {
			showAdvisorNotesToaster(
				t(
					'printer.error',
					'We encountered an unexpected issue while trying to save the profile notes. Please try again.'
				)
			);
		}
	};

	return (
		<>
			{children({
				openAdvisorNotes,
				showAdvisorNotesToaster,
				getAuthToken,
			})}

			<NotesModal
				dialogRef={dialogRef}
				prospectusId={prospectusID}
				notes={notes}
				modalClose={modalCloseHandler}
				modalSave={modalSaveHandler}
			/>

			{showToast && <SmallToast toastText={alertText} />}
		</>
	);
}